import styled from "styled-components"

export const MasterImageWrapper = styled.div`
  margin-bottom: 15px;

  img {
    width: 100%;
    margin-top: 20px;
  }
  h1 {
    margin-bottom: 4px;
    font-size: 28px;
    font-weight: 700;
    line-height: 30.8px;
  }
  text {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
  }
`;
